import {
  SHOW_MODAL_FORM,
  HIDE_MODAL_FORM,
} from './types';


export const showModalForm = (form) => dispatch => {
    dispatch({
        type: SHOW_MODAL_FORM,
        form: form,
        payload: true
    })
}


export const hideModalForm = (form) => dispatch => {
    dispatch({
        type: HIDE_MODAL_FORM,
        form: form,
        payload: false
    })
}